export const ORGANIZATION_CONTACT = {
  telephone: '+1-310-899-1960',
  email: 'info@goodingco.com',
  contactType: 'customer service',
};

// Historical / trade names the entity is also known by. Confirmed by the
// brand team — surfaced via Schema.org `alternateName` so search engines
// and AI answer engines link these variants to the same Organization
// (reduces ambiguity between "Gooding Christie's", the legal name today,
// and the older "Gooding & Company" branding still present on news
// articles, social profiles, and partner pages).
export const ORGANIZATION_ALTERNATE_NAMES = [
  'Gooding & Company',
  'Gooding & Company, LLC',
  'Gooding & Co.',
  'Gooding and Company',
  'Gooding',
];
